module.exports = __webpack_public_path__ + "img/union.a28d7d30.png";